import React from "react";
import { Button, Dropdown, Menu } from "antd";

import { Icons } from "components/layout";
import TranslatedText from "components/service/translated-text";
import Localize from "components/service/localize";
import { TRANSLATION_FIELD_TYPES } from "mock-data/translation/languages";

import CommentsHelpers from "./helpers";

export const AttachmentItem = ({ attachment, onDelete }) => {
    const parts = CommentsHelpers.Mappers.splitFileName(attachment.name, attachment.extension);
    const fullName = `${ parts.base }${ parts.extension }`;

    const content = (
        <>
            <Icons.Attachment />
            <span className="file-title">
                <span className="file-base">{ parts.base }</span>
                <span className="file-ext">{ parts.extension }</span>
            </span>
        </>
    );

    if (onDelete) {
        return (
            <li>
                <div className="file" title={ fullName }>{ content }</div>
                <button type="button" onClick={ () => onDelete(attachment.id) }>
                    <Icons.Delete />
                </button>
            </li>
        );
    }

    return (
        <li>
            <a href={ attachment.path } target="_blank" rel="noreferrer" title={ fullName }>
                { content }
            </a>
        </li>
    );
};

const buildCommentMenu = ({ commentId, onEdit, onDelete }) => (
    <Menu
        items={[
            {
                key: "edit",
                label: (
                    <span className="menu-item">
                        <Icons.Edit />
                        <Localize>STAND.Text_EditComment</Localize>
                    </span>
                )
            },
            {
                key: "delete",
                label: (
                    <span className="menu-item">
                        <Icons.Delete />
                        <Localize>STAND.Text_DeleteComment</Localize>
                    </span>
                )
            }
        ]}
        onClick={ ({ key }) => {
            if (key === "edit") onEdit(commentId);
            if (key === "delete") onDelete(commentId);
        } }
    />
);

const StandCommentItem = ({ comment, canManage, onEdit, onDelete, moment }) => (
    <li>
        <span className="comment-date">
            { moment(comment.createdAt).format("DD.MM.YYYY | HH:mm") }
        </span>
        <div className="stand-comments-item bg-light-bordered">
            <div className="head">
                <h4>{ comment.author || "—" }</h4>
                { canManage &&
                    <Dropdown
                        arrow
                        overlay={ buildCommentMenu({ commentId: comment.id, onEdit, onDelete }) }
                        trigger={[ "click" ]}
                        overlayClassName="drop-more-menu"
                    >
                        <Button type="default" className="icon round comment-menu-btn">
                            <Icons.ThreeDot />
                        </Button>
                    </Dropdown>
                }
            </div>
            <p className="text">
                <TranslatedText
                    text={ comment.text }
                    namespace={ TRANSLATION_FIELD_TYPES.comment }
                    context={ `stand-comment:${ comment.id }` }
                    fallback="—"
                />
            </p>
            { !!comment.attachments.length &&
                <ul className="attachment-list">
                    { comment.attachments.map((attachment) => (
                        <AttachmentItem key={ attachment.id } attachment={ attachment } />
                    )) }
                </ul>
            }
        </div>
    </li>
);

export default StandCommentItem;
